<template>
    <div>
        <draft-menu></draft-menu>
        <v-container fluid style="height: 100vh; overflow: hidden;">
            <v-layout
                fill-height
                justify-center
                fluid
                wrap
                :pa-5="$vuetify.breakpoint.xlOnly"
            >
                <v-flex shrink xs12>
                    <v-layout fluid row wrap v-if="$vuetify.breakpoint.mdAndUp">
                        <v-flex>
                            <h1 class="display-4">
                                The Draft
                            </h1>
                            <v-layout row justify-start>
                                <v-flex md4>
                                    <h2>
                                        <span
                                            class="heading indigo--text text--lighten-2"
                                            v-if="numberOfRounds > 1"
                                        >
                                            Round {{ currentRound + 1 }} of
                                            {{ numberOfRounds }}
                                        </span>
                                    </h2>
                                </v-flex>
                                <v-flex md4>
                                    <h2>
                                        <span
                                            class="heading indigo--text text--lighten-1"
                                        >
                                            Pick #{{ playersPicked + 1 }} of
                                            {{ playersPerRound }}
                                        </span>
                                    </h2>
                                </v-flex>
                            </v-layout>
                            <h2 class="display-2">
                                <span class="indigo--text font-weight-black">{{
                                    onTheClock.name
                                }}</span>
                                is on the clock
                            </h2>
                            <h3 class="display-1">
                                <span class="green--text font-weight-bold">{{
                                    getNextTeam.name
                                }}</span>
                                is up next
                            </h3>
                        </v-flex>
                        <v-spacer></v-spacer>
                        <v-flex>
                            <v-layout align-center>
                                <h1
                                    class="display-4"
                                    :class="{ 'red-text': timeShort }"
                                >
                                    {{ minutes }} : {{ seconds }}
                                </h1>
                                <v-btn
                                    fab
                                    flat
                                    color="green"
                                    large
                                    icon
                                    @click="pause"
                                    ><v-icon>pause</v-icon></v-btn
                                >
                            </v-layout>
                        </v-flex>
                    </v-layout>
                    <v-layout
                        fluid
                        row
                        wrap
                        v-if="$vuetify.breakpoint.smOnly"
                        px-3
                    >
                        <v-flex sm9>
                            <h1 class="display-3">
                                The Draft
                            </h1>
                            <h2 class="display-2">
                                <span class="indigo--text font-weight-black">{{
                                    onTheClock.name
                                }}</span>
                                is on the clock
                            </h2>
                            <h3 class="display-1">
                                <span class="green--text font-weight-bold">{{
                                    getNextTeam.name
                                }}</span>
                                is up next
                            </h3>
                            <h2>
                                <span
                                    class="heading indigo--text text--lighten-2"
                                    v-if="numberOfRounds > 1"
                                >
                                    Round {{ currentRound + 1 }} of
                                    {{ numberOfRounds }}
                                </span>
                            </h2>
                            <h2>
                                <span
                                    class="heading indigo--text text--lighten-1"
                                >
                                    Pick #{{ playersPicked + 1 }} of
                                    {{ playersPerRound }}
                                </span>
                            </h2>
                        </v-flex>
                        <v-flex sm3 class="text-sm-right">
                            <v-layout align-center>
                                <h1
                                    class="display-4"
                                    :class="{ 'red-text': timeShort }"
                                >
                                    {{ minutes }}<br />{{ seconds }}
                                </h1>
                                <v-btn
                                    fab
                                    flat
                                    color="green"
                                    large
                                    icon
                                    @click="pause"
                                    ><v-icon>pause</v-icon></v-btn
                                >
                            </v-layout>
                        </v-flex>
                    </v-layout>
                    <v-layout
                        fluid
                        row
                        wrap
                        v-if="$vuetify.breakpoint.xsOnly"
                        align-center
                        px-2
                    >
                        <v-flex xs8 align-self-start>
                            <v-layout align-start wrap>
                                <v-flex xs12>
                                    <h2 class="display-2">
                                        <span
                                            class="indigo--text font-weight-black"
                                            >{{ onTheClock.name }}</span
                                        >
                                    </h2>
                                </v-flex>
                                <v-flex xs12>
                                    <h2>
                                        <span
                                            class="green--text font-weight-bold"
                                            >{{ getNextTeam.name }}</span
                                        >
                                        up next
                                    </h2>
                                </v-flex>
                                <v-flex xs12>
                                    <h2>
                                        <span
                                            class="subheading indigo--text text--lighten-1"
                                        >
                                            Pick #{{ playersPicked + 1 }} of
                                            {{ playersPerRound }}
                                        </span>
                                    </h2>
                                </v-flex>
                                <v-flex xs12>
                                    <h2>
                                        <span
                                            class="subheading indigo--text text--lighten-2"
                                            v-if="numberOfRounds > 1"
                                        >
                                            Round {{ currentRound + 1 }} of
                                            {{ numberOfRounds }}
                                        </span>
                                    </h2>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex xs4>
                            <v-layout
                                wrap
                                class="text-xs-center"
                                align-center
                                fill-height
                            >
                                <v-flex>
                                    <h1
                                        class="display-1 font-weight-black"
                                        :class="{ 'red-text': timeShort }"
                                    >
                                        {{ minutes }} : {{ seconds }}
                                    </h1>
                                </v-flex>
                                <v-flex>
                                    <v-btn
                                        flat
                                        color="green"
                                        icon
                                        large
                                        class="ma-0"
                                        @click="pause"
                                        ><v-icon>pause</v-icon></v-btn
                                    >
                                </v-flex>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex xs12 grow>
                    <v-layout
                        row
                        wrap
                        fluid
                        :align-center="$vuetify.breakpoint.xsOnly"
                    >
                        <v-flex lg6 md6 xs12 pa-3>
                            <v-toolbar>
                                <v-layout row wrap>
                                    <v-flex xs12 sm4>
                                        <h1
                                            :class="{
                                                subheading:
                                                    $vuetify.breakpoint.xsOnly
                                            }"
                                        >
                                            Available Players
                                        </h1>
                                    </v-flex>
                                    <v-spacer
                                        class="hidden-md-and-down"
                                    ></v-spacer>
                                    <v-flex
                                        xs4
                                        sm3
                                        lg3
                                        pb-1
                                        :py-3="$vuetify.breakpoint.mdOnly"
                                    >
                                        <v-btn-toggle v-model="selectedGender">
                                            <v-btn
                                                flat
                                                :small="
                                                    $vuetify.breakpoint.xsOnly
                                                "
                                                value="All"
                                            >
                                                All
                                            </v-btn>
                                            <v-btn
                                                flat
                                                :small="
                                                    $vuetify.breakpoint.xsOnly
                                                "
                                                value="F"
                                            >
                                                F
                                            </v-btn>
                                            <v-btn
                                                flat
                                                :small="
                                                    $vuetify.breakpoint.xsOnly
                                                "
                                                value="M"
                                            >
                                                M
                                            </v-btn>
                                        </v-btn-toggle>
                                    </v-flex>
                                    <v-spacer
                                        class="hidden-sm-and-up"
                                    ></v-spacer>
                                    <v-flex
                                        xs6
                                        sm4
                                        lg3
                                        pb-1
                                        :py-3="$vuetify.breakpoint.mdOnly"
                                    >
                                        <v-text-field
                                            class="pa-0 pl-3"
                                            v-model="search"
                                            append-icon="search"
                                            label="Search"
                                            single-line
                                            hide-details
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-toolbar>
                            <v-data-table
                                :class="{
                                    'mobile-list':
                                        $vuetify.breakpoint.smAndDown,
                                    'large-list': $vuetify.breakpoint.mdAndUp
                                }"
                                :items="filteredPlayers"
                                hide-actions
                                :search="search"
                                :headers="headers"
                                hide-headers
                            >
                                <template v-slot:items="props">
                                    <tr
                                        @click="playerConfirm(props.item)"
                                        :disabled="
                                            wait || paused || roundMessage
                                        "
                                        style="height: 60px;"
                                    >
                                        <td>{{ props.index + 1 }}</td>
                                        <td class="text-capitalize">
                                            {{ props.item.name }}
                                        </td>
                                        <td>
                                            <v-avatar>
                                                <img
                                                    :src="props.item.picture"
                                                    v-if="
                                                        props.item.picture !==
                                                            ''
                                                    "
                                                />
                                                <v-icon color="indigo" v-else
                                                    >account_circle</v-icon
                                                >
                                            </v-avatar>
                                        </td>
                                    </tr>
                                </template>
                                <template v-slot:no-data>
                                    <h1
                                        class="indigo--text text--darken-4 mx-auto font-weight-thin"
                                    >
                                        No players left!
                                    </h1>
                                </template>
                            </v-data-table>
                        </v-flex>
                        <v-flex lg6 md6 xs12 pa-3>
                            <v-toolbar>
                                <h1>Current Roster</h1>
                                <v-spacer></v-spacer>
                            </v-toolbar>
                            <v-data-table
                                :class="{
                                    'mobile-list':
                                        $vuetify.breakpoint.smAndDown,
                                    'large-list': $vuetify.breakpoint.mdAndUp
                                }"
                                :items="onTheClock.roster"
                                hide-actions
                                :headers="headers"
                                hide-headers
                            >
                                <template v-slot:items="props">
                                    <tr style="height: 60px;">
                                        <td>{{ props.index + 1 }}</td>
                                        <td class="text-capitalize">
                                            {{ props.item.name }}
                                        </td>
                                        <td>
                                            <v-avatar>
                                                <img
                                                    :src="props.item.picture"
                                                    v-if="
                                                        props.item.picture !==
                                                            ''
                                                    "
                                                />
                                                <v-icon color="indigo" v-else
                                                    >account_circle</v-icon
                                                >
                                            </v-avatar>
                                        </td>
                                    </tr>
                                </template>
                                <template v-slot:no-data>
                                    <h1
                                        class="indigo--text text--darken-4 font-weight-thin"
                                    >
                                        No players yet
                                    </h1>
                                </template>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-dialog v-model="dialog" max-width="400px">
                    <v-card>
                        <v-card-title>
                            <span class="headline"
                                >Would you like to select this player?</span
                            >
                        </v-card-title>

                        <v-card-text>
                            <v-container fluid>
                                <v-layout wrap>
                                    <v-flex xs4>
                                        <v-avatar>
                                            <img :src="clickedPlayer.picture" />
                                        </v-avatar>
                                    </v-flex>
                                    <v-flex xs8>
                                        <h3 class="text-capitalize">
                                            {{ clickedPlayer.name }}
                                        </h3>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                color="green darken-1"
                                flat
                                @click="addPlayer"
                                >Yes</v-btn
                            >
                            <v-btn color="red darken-1" flat @click="close"
                                >No</v-btn
                            >
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-layout>
            <v-snackbar
                v-model="draftUpdate"
                :timeout="5000"
                bottom
                color="indigo"
                :vertical="$vuetify.breakpoint.smAndDown"
                id="snack"
            >
                {{ snackMessage }}
                <v-btn color="white" flat @click="draftUpdate = false">
                    Close
                </v-btn>
            </v-snackbar>
            <v-fade-transition>
                <v-container fluid class="pause-overlay" v-show="paused">
                    <v-layout
                        row
                        justify-center
                        align-center
                        fill-height
                        class="text-xs-center"
                    >
                        <v-flex>
                            <h1
                                class="white--text font-weight-bold text-uppercase"
                                :class="{
                                    'display-4': $vuetify.breakpoint.mdAndUp,
                                    'display-3': $vuetify.breakpoint.smAndDown
                                }"
                            >
                                Paused
                            </h1>
                            <v-btn
                                large
                                color="indigo lighten-2"
                                @click="resume"
                                >Resume</v-btn
                            >
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-fade-transition>
            <v-fade-transition>
                <v-container
                    fluid
                    class="round-message-overlay"
                    v-show="roundMessage"
                >
                    <v-layout
                        row
                        justify-center
                        align-center
                        fill-height
                        class="text-xs-center"
                    >
                        <v-flex>
                            <h1
                                class="mb-5 indigo--text text--darken-3 font-weight-thin text-uppercase"
                                :class="{
                                    'display-4': $vuetify.breakpoint.mdAndUp,
                                    'display-3': $vuetify.breakpoint.smAndDown
                                }"
                            >
                                Round {{ currentRound + 1 }}
                            </h1>
                            <h2
                                class="indigo--text"
                                :class="{
                                    'display-3': $vuetify.breakpoint.mdAndUp,
                                    'display-2': $vuetify.breakpoint.smAndDown
                                }"
                            >
                                <span
                                    class="font-weight-black indigo--text text--darken-2"
                                    >{{ onTheClock.name }}</span
                                >
                                will be on the clock.
                            </h2>
                            <v-btn
                                large
                                color="indigo lighten-2 white--text"
                                @click="beginRound"
                                >Begin Round</v-btn
                            >
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-fade-transition>
            <v-fade-transition>
                <v-container
                    fluid
                    class="draft-completed-overlay"
                    v-show="draftComplete"
                >
                    <v-layout
                        row
                        justify-center
                        align-center
                        fill-height
                        class="text-xs-center"
                    >
                        <v-flex>
                            <h1
                                class="mb-5 indigo--text text--darken-3 font-weight-thin text-uppercase"
                                :class="{
                                    'display-4': $vuetify.breakpoint.mdAndUp,
                                    'display-3': $vuetify.breakpoint.smAndDown
                                }"
                            >
                                Draft Completed
                            </h1>
                            <h2
                                class="indigo--text"
                                :class="{
                                    'display-3': $vuetify.breakpoint.mdAndUp,
                                    'display-2': $vuetify.breakpoint.smAndDown
                                }"
                            >
                                Let's view the final rosters.
                            </h2>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-fade-transition>
        </v-container>
        <v-btn absolute class="rosters-button" @click="displayRosters = !displayRosters" :class="{ 'show': displayRosters }">See All Rosters</v-btn>
        <v-container fluid class="rosters-drawer" :class="{ 'show': displayRosters }">
          <v-btn absolute class="close-button" large icon @click="displayRosters = !displayRosters"><v-icon large>close</v-icon></v-btn>
          <v-container
              my-3
              v-bind="{ [`grid-list-md`]: true }"
              fluid
              pt-5
              style="overflow: auto; max-height: 70vh;"
          >
              <v-layout row wrap>
                  <v-flex
                      v-for="(item, index) in teams"
                      :key="index"
                      xs12
                      sm6
                      md4
                      lg3
                  >
                      <v-card tile height="auto">
                          <v-toolbar color="indigo" dark>
                              <v-avatar class="mx-3">
                                  <img
                                      :src="item.picture"
                                      v-if="item.picture !== ''"
                                  />
                                  <v-icon color="white" v-else>star</v-icon>
                              </v-avatar>
                              <v-spacer></v-spacer>
                              <v-toolbar-title>{{
                                  item.name
                              }}</v-toolbar-title>
                          </v-toolbar>
                          <v-list>
                              <v-list-tile
                                  v-for="(player, index) in item.roster"
                                  :key="index"
                                  avatar
                              >
                                  <v-list-tile-action>
                                      <v-list-tile-action-text
                                          v-text="index + 1"
                                      ></v-list-tile-action-text>
                                  </v-list-tile-action>

                                  <v-list-tile-content>
                                      <v-list-tile-title
                                          v-text="player.name"
                                          class="text-capitalize"
                                      ></v-list-tile-title>
                                  </v-list-tile-content>

                                  <v-list-tile-avatar>
                                      <img :src="player.picture" />
                                  </v-list-tile-avatar>
                              </v-list-tile>
                          </v-list>
                      </v-card>
                  </v-flex>
              </v-layout>
          </v-container>
        </v-container>
    </div>
</template>

<script>
import DraftMenu from '@/components/DraftMenu';

export default {
    name: 'Draft',
    components: {
        DraftMenu
    },
    created() {
        this.teams = this.$store.state.teams;
        this.onTheClock = this.teams[0];
        this.availablePlayers = this.$store.state.players.sort(function(a, b) {
            return b.rating - a.rating;
        });
        this.totalPlayers = this.$store.state.numberOfPlayers;
        this.numberOfRounds = this.$store.state.numberOfRounds;
        this.roundMessage = this.numberOfRounds > 1 ? true : false;
        this.playersPerRound = this.$store.state.numberOfPlayersPerRound;
        this.autodraft = this.$store.state.autodraft;
    },
    mounted() {
        if (this.numberOfRounds === 1) {
            this.startTimer();
        }
    },
    data() {
        return {
            onTheClock: '',
            teams: [],
            headers: [
                { text: 'Rank' },
                { text: 'Name', value: 'name' },
                { text: 'picture', value: 'picture' }
            ],
            currentTeam: 0,
            direction: 'forward',
            timeLeft: 120,
            timer: null,
            totalPlayers: 0,
            availablePlayers: [],
            clickedPlayer: {
                name: '',
                picture: ''
            },
            defaultPlayer: {
                name: '',
                picture: ''
            },
            dialog: false,
            paused: false,
            numberOfRounds: 0,
            currentRound: 0,
            roundMessage: false,
            playersPicked: 0,
            playersPerRound: 0,
            wait: false,
            draftComplete: false,
            autodraft: false,
            draftUpdate: false,
            search: '',
            selectedGender: 'All',
            displayRosters: false,
        };
    },
    methods: {
        startTimer() {
            this.timer = setInterval(() => this.countdown(), 1000);
        },
        resetTimer() {
            this.timeLeft = 120;
            clearInterval(this.timer);
            this.timer = null;
        },
        pauseTimer() {
            clearInterval(this.timer);
        },
        padTime(time) {
            return (time < 10 ? '0' : '') + time;
        },
        countdown() {
            if (this.timeLeft >= 1) {
                this.timeLeft--;
            } else {
                this.timeLeft = 0;
                if (this.autodraft && this.dialog === false) {
                    this.pauseTimer();
                    this.performAutodraft();
                }
            }
        },
        performAutodraft() {
            this.clickedPlayer = this.availablePlayers[0];
            this.addPlayer();
        },
        playerConfirm(player) {
            this.dialog = true;
            this.clickedPlayer = player;
        },
        addPlayer() {
            this.draftUpdate = false;
            var _this = this;
            this.onTheClock.roster.push(this.clickedPlayer);
            Object.assign(this.teams[this.currentTeam], this.onTheClock);
            const index = this.availablePlayers.indexOf(this.clickedPlayer);
            this.availablePlayers.splice(index, 1);
            if (this.availablePlayers.length === 0) {
                this.$store.commit('setTeams', this.teams);
                this.draftComplete = true;
                clearInterval(this.timer);
                setTimeout(function() {
                    _this.$router.push('final-rosters');
                }, 2000);
            } else {
                this.dialog = false;
                this.clickedPlayer = this.defaultPlayer;
                this.playersPicked++;
                this.wait = true;
                setTimeout(function() {
                    _this.nextTeam();
                    _this.resetTimer();
                    _this.wait = false;
                    if (
                        _this.playersPicked >= _this.playersPerRound &&
                        _this.currentRound !== _this.numberOfRounds
                    ) {
                        _this.currentRound++;
                        _this.playersPicked = 0;
                        _this.roundMessage = true;
                        _this.draftUpdate = true;
                    } else {
                        _this.startTimer();
                        _this.draftUpdate = true;
                    }
                }, 1000);
            }
        },
        close() {
            this.clickedPlayer = this.defaultPlayer;
            this.dialog = false;
        },
        nextTeam() {
            const numTeams = this.teams.length;
            if (this.direction === 'forward') {
                if (this.currentTeam === numTeams - 1) {
                    this.direction = 'backward';
                } else {
                    this.currentTeam++;
                }
            } else {
                if (this.currentTeam === 0) {
                    this.direction = 'forward';
                } else {
                    this.currentTeam--;
                }
            }
            this.onTheClock = this.teams[this.currentTeam];
        },
        pause() {
            this.paused = true;
            this.pauseTimer();
        },
        resume() {
            this.paused = false;
            this.startTimer();
        },
        beginRound() {
            this.roundMessage = false;
            this.startTimer();
        },
        capitalize(str) {
            str = str.split(' ');

            for (var i = 0, x = str.length; i < x; i++) {
                str[i] = str[i][0].toUpperCase() + str[i].substr(1);
            }

            return str.join(' ');
        }
    },
    computed: {
        minutes() {
            const minutes = Math.floor(this.timeLeft / 60);
            return this.padTime(minutes);
        },
        seconds() {
            const seconds = this.timeLeft - this.minutes * 60;
            return this.padTime(seconds);
        },
        getNextTeam() {
            const numTeams = this.teams.length;
            let upNext;
            if (this.direction === 'forward') {
                if (this.currentTeam === numTeams - 1) {
                    upNext = this.currentTeam;
                } else {
                    upNext = this.currentTeam + 1;
                }
            } else {
                if (this.currentTeam === 0) {
                    upNext = this.currentTeam;
                } else {
                    upNext = this.currentTeam - 1;
                }
            }
            return this.teams[upNext];
        },
        getPreviousTeam() {
            const numTeams = this.teams.length;
            let upBefore;
            if (this.direction === 'forward') {
                if (this.currentTeam === 0) {
                    upBefore = this.currentTeam;
                } else {
                    upBefore = this.currentTeam - 1;
                }
            } else {
                if (this.currentTeam === numTeams - 1) {
                    upBefore = this.currentTeam;
                } else {
                    upBefore = this.currentTeam + 1;
                }
            }
            return this.teams[upBefore];
        },
        snackMessage() {
            if (this.availablePlayers.length === this.totalPlayers) {
                return "Uh-oh this shoudn't happen";
            } else {
                let previousTeam = this.getPreviousTeam;
                return (
                    previousTeam.name +
                    ' selects ' +
                    this.capitalize(
                        previousTeam.roster[previousTeam.roster.length - 1].name
                    ) +
                    ' with pick #' +
                    (this.totalPlayers - this.availablePlayers.length) +
                    '.'
                );
            }
        },
        timeShort() {
            return this.timeLeft <= 10 ? true : false;
        },
        filteredPlayers() {
            return this.selectedGender === 'All'
                ? this.availablePlayers
                : this.availablePlayers.filter(
                      player =>
                          player.gender.toLowerCase() ===
                          this.selectedGender.toLowerCase()
                  );
        }
    }
};
</script>

<style scoped>
.mobile-list {
    overflow: scroll;
    max-height: 35vh;
}
.large-list {
    max-height: 60vh;
    overflow: auto;
}
.red-text {
    color: red;
}
.pause-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 10001;
}
.round-message-overlay,
.draft-completed-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(255, 255, 255, 0.9);
    z-index: 10001;
}
#snack {
    z-index: 10002;
}

.rosters-button {
  top: 30vh;
  height: 40px;
  width: 150px;
  -moz-transform:rotate(-90deg);
    -ms-transform:rotate(-90deg);
      -o-transform:rotate(-90deg);
        -webkit-transform:rotate(-90deg);
  right: -55px;
  padding: 0;
  margin: 0;
  opacity: 1;
  transition: opacity 1s ease-out;
}

.rosters-button.show {
  right: 100vw;
  opacity: 0;
}

.rosters-drawer {
  width: 100vw;
  height: 100vh;
  top: 0;
  bottom: 0;
  position: absolute;
  right: -100vw;
  transition: right 1s ease-in;
  background-color: rgba(63, 81, 181, 0.75);
}

.rosters-drawer.show {
  right: 0;
}

.close-button {
  top: 0;
  right: 0;
  color: white;
}

@media all and (max-width: 767.98px) {
  .rosters-button {
    top: 20vh;
    height: 30px;
    width: 100px;
    right: -35px;
    font-size: 0.8rem;
  }
}
</style>
